// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v6.32.1
// source: builtin_interfaces/msg/Time.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "builtin_interfaces.msg.pb";

/**
 * This message communicates ROS Time defined here:
 * https://design.ros2.org/articles/clock_and_time.html
 */
export interface Time {
  /** The seconds component, valid over all int32 values. */
  sec: number;
  /**
   * The nanoseconds component, valid in the range [0, 1e9), to be added to the seconds component.
   * e.g.
   * The time -1.7 seconds is represented as {sec: -2, nanosec: 3e8}
   * The time 1.7 seconds is represented as {sec: 1, nanosec: 7e8}
   */
  nanosec: number;
}

function createBaseTime(): Time {
  return { sec: 0, nanosec: 0 };
}

export const Time: MessageFns<Time> = {
  encode(message: Time, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.sec !== 0) {
      writer.uint32(775781885).sfixed32(message.sec);
    }
    if (message.nanosec !== 0) {
      writer.uint32(3563288613).fixed32(message.nanosec);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Time {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTime();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 96972735: {
          if (tag !== 775781885) {
            break;
          }

          message.sec = reader.sfixed32();
          continue;
        }
        case 445411076: {
          if (tag !== 3563288613) {
            break;
          }

          message.nanosec = reader.fixed32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Time {
    return {
      sec: isSet(object.sec) ? globalThis.Number(object.sec) : 0,
      nanosec: isSet(object.nanosec) ? globalThis.Number(object.nanosec) : 0,
    };
  },

  toJSON(message: Time): unknown {
    const obj: any = {};
    if (message.sec !== 0) {
      obj.sec = Math.round(message.sec);
    }
    if (message.nanosec !== 0) {
      obj.nanosec = Math.round(message.nanosec);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Time>, I>>(base?: I): Time {
    return Time.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Time>, I>>(object: I): Time {
    const message = createBaseTime();
    message.sec = object.sec ?? 0;
    message.nanosec = object.nanosec ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
